<template>
  <div class="page-active">
    <div class="conetent">
      <div v-for="(item, index) in list" :key="index" class="content-box">
        <div class="product-box" @click="goOrder(item)">
          <div class="image">
            <img :src="item.photos" alt="">
          </div>
          <div class="name ellipsis">{{item.productName}}</div>
          <div class="price">{{item.price | price}}</div>
        </div>
      </div>
    </div>
    <div v-if="!list.length" class="footer">该品类已售罄</div>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      list: [],
    }
  },
  async mounted() {
    if (this.$route.query.isPay === 'true') {
      this.$router.replace({name: 'offlineActive', query: {...this.$route.query, isPay: false}})
      Toast.success('支付成功')
    }
    try {
      this.list = await this.$store.dispatch('offine/getGoodsList', this.$route.query.price)
    } catch (error) {
      console.log(error);
    }
    
  },
  methods: {
    goOrder(item) {
      this.$router.push({name: 'offineSumbit', query: {obj: JSON.stringify(item)}})
    }
  }
}
</script>
<style lang="less" scoped>
.page-active {
  height: 100%;
  overflow-y: auto;
  position: relative;
  .conetent {
    padding: 0.25rem;
    overflow: hidden;
    .content-box {
      width: 50%;
      box-sizing: border-box;
      float: left;
      padding: 0.25rem;
      .product-box {
        background: #fff;
        text-align: center;
        .image {
          height: 175.5px;
          max-width: 100%;
          overflow: hidden;
          img {
            width: 100%;
            // height: 100%;
          }
        }
        .name {
          padding: 0 15px;
          height: 30px;
          line-height: 30px;
        }
        .price {
          height: 35px;
          line-height: 35px;
          font-size: 18px;
          color: #c30d24;   
        }
      }
    }
  }
  // .over-ellipsis {
  //   text-overflow: -o-ellipsis-lastline;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  //   display: -webkit-box;
  //   -webkit-line-clamp: 2;
  //   line-clamp: 2;
  //   -webkit-box-orient: vertical;
  // }
  .footer {
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>